// extracted by mini-css-extract-plugin
export default {"vdsWorkaround":"CasFormCheckbox_vdsWorkaround__HCScp"};